<ng-container *transloco="let t">

  <div class="layout-header p-d-flex p-ai-center p-jc-between">
    <div>
      <h1><app-back-button></app-back-button>{{ title }}</h1>
    </div>
    <div *ngIf="group !== null && slot !== null" class="p-d-flex p-ai-center p-jc-between control-section">
      <div>
        <ng-container *ngFor="let actual of group?.candidates">
          <app-avatar
            *ngIf="slot.exercise.isTeam() || candidate === null || candidate.hashed_id === actual.hashed_id"
            [user]="actual"
            [type]="'candidate'"
            [mode]="'small'"
            [white]="true"
            [tooltipPosition]="'bottom'"
            [inactive]="!group.isLinkedToCandidate(actual.hashed_id, auth.getHashedId())"
          ></app-avatar>
        </ng-container>
      </div>
      <div>
        <ng-container *ngFor="let observer of group?.observers">
          <app-avatar
            [user]="observer"
            [type]="'observer'"
            [mode]="'small'"
            [white]="true"
            [tooltipPosition]="'bottom'"
          ></app-avatar>
        </ng-container>
      </div>
      <div>
        <app-content-controls
          [group]="group"
          [candidate]="candidate"
          [exercise]="slot.exercise"
        ></app-content-controls>
      </div>
      <div>
        <app-timer [slot]="slot" [candidate]="candidate" [group]="group" [mode]="mode"></app-timer>
      </div>
    </div>
  </div>

</ng-container>
